export const getPhoneNumber = me => me && me.profile && me.profile.phoneNumber;
